import React from "react";
import CustomerSettingsEdit from "../components/customers/CustomerSettingsEdit";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function CustomerSettingsPage() {

  return (
    <div>
      <TitleUpdater />
      <CustomerSettingsEdit />
    </div>
  );
}
